import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
      getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminGpsmap1243xsv = () => {
  console.log('🎯 GarminGpsmap1243xsv component loading');
  
  const product = findProductById("gpsmap-1243xsv");
  
  if (!product) {
    console.error('Product not found:', "gpsmap-1243xsv");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-1243xsv"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminGpsmap1243xsv; 